import { __awaiter, __decorate, __param } from "tslib";
import { JSONSerializer } from '@genesislcap/foundation-utils';
import { DI } from '@microsoft/fast-foundation';
/**
 * The default implementation of the Http interface.
 * @public
 */
let DefaultHttp = class DefaultHttp {
    constructor(serializer) {
        this.serializer = serializer;
    }
    get(url, requestInit) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(url, Object.assign(Object.assign({}, requestInit), { method: 'GET' }));
            const serializer = requestInit.serializer || this.serializer;
            return serializer.deserialize(response);
        });
    }
    post(url, requestInit) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(url, Object.assign(Object.assign({}, requestInit), { method: 'POST' }));
            const serializer = requestInit.serializer || this.serializer;
            return serializer.deserialize(response);
        });
    }
};
DefaultHttp = __decorate([
    __param(0, JSONSerializer)
], DefaultHttp);
export { DefaultHttp };
/**
 * The DI token for the Http interface.
 * @internal
 */
export const Http = DI.createInterface((x) => x.singleton(DefaultHttp));
